module.exports = __webpack_public_path__ + "img/small-pump-left.9e5d92f8.png";